import React, { useEffect, useState } from "react";
import { api, fmtUSD, fmtDate } from "../../lib/api";

const AdminUsers = () => {
  const [users, setUsers] = useState([]);
  useEffect(() => { api.get("/admin/users").then(({ data }) => setUsers(data)); }, []);

  return (
    <div className="space-y-8">
      <div>
        <div className="overline">Operator console</div>
        <h1 className="font-display text-4xl mt-1">Customers</h1>
      </div>
      <div className="bg-[hsl(var(--surface))] border border-[hsl(var(--border))]">
        <table className="w-full text-sm">
          <thead className="border-b border-[hsl(var(--border))]">
            <tr className="text-left">
              <th className="overline py-3 px-4">Name</th>
              <th className="overline py-3 px-4">Email</th>
              <th className="overline py-3 px-4">Role</th>
              <th className="overline py-3 px-4 text-right">Accounts</th>
              <th className="overline py-3 px-4 text-right">Balance</th>
              <th className="overline py-3 px-4">Joined</th>
            </tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.id} className="border-b border-[hsl(var(--border))]" data-testid={`user-${u.id}`}>
                <td className="py-3 px-4 font-medium">{u.name}</td>
                <td className="py-3 px-4 font-mono text-xs">{u.email}</td>
                <td className="py-3 px-4 capitalize">{u.role}</td>
                <td className="py-3 px-4 text-right font-mono">{u.accounts_count}</td>
                <td className="py-3 px-4 text-right font-mono">{fmtUSD(u.total_balance)}</td>
                <td className="py-3 px-4 font-mono text-xs">{fmtDate(u.created_at)}</td>
              </tr>
            ))}
            {users.length === 0 && (
              <tr><td colSpan={6} className="py-12 text-center text-[hsl(var(--text-muted))]">No customers yet.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminUsers;
